import { useEffect, useRef, type DependencyList, type EffectCallback } from 'react';

export const useDidUpdateEffect = (effect: EffectCallback, deps: DependencyList) => {
  const didMountRef = useRef(false);

  useEffect(() => {
    if (!didMountRef.current) {
      didMountRef.current = true;
      return;
    }

    return effect();
  }, deps);
};
